  document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.story-slider');
    let isDown = false, startX, scrollLeft;

    slider.addEventListener('mousedown', e => {
      isDown = true;
      slider.classList.add('active-grab');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      e.preventDefault();
    });

    ['mouseup', 'mouseleave'].forEach(evt =>
      slider.addEventListener(evt, () => {
        isDown = false;
        slider.classList.remove('active-grab');
      })
    );

    slider.addEventListener('mousemove', e => {
      if (!isDown) return;
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });

    // Impedisce il drag delle immagini
    slider.querySelectorAll('img').forEach(img => img.ondragstart = () => false);
  });

 